import React from 'react'

const FacebookIcon = props => (
  <svg {...props } width="9" height="17" viewBox="0 0 9 17" fill="#616164" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.73893 5.55745H6.05165V3.78767C6.03874 3.68696 6.04798 3.58464 6.0787 3.48786C6.10942 3.39109 6.16088 3.30218 6.22951 3.22734C6.29813 3.15251 6.38226 3.09355 6.47602 3.05459C6.56979 3.01562 6.67092 2.99758 6.77237 3.00174H8.67372V0.0524776H6.118C5.64067 0.0146019 5.16078 0.0796083 4.71073 0.243105C4.26068 0.406603 3.85096 0.664782 3.50925 1.0002C3.16753 1.33563 2.90179 1.74048 2.72996 2.18741C2.55813 2.63435 2.48422 3.11295 2.51322 3.5909V5.4911H0.875V8.50557H2.51322V16.9587H6.05165V8.50557H8.41174L8.73893 5.55745Z" />
  </svg>
)

export default FacebookIcon
